module.exports = __webpack_public_path__ + "static/img/farming.f890018b.png";